var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00033 1.16797C3.78033 1.16797 1.16699 3.7813 1.16699 7.0013C1.16699 10.2213 3.78033 12.8346 7.00033 12.8346C10.2203 12.8346 12.8337 10.2213 12.8337 7.0013C12.8337 3.7813 10.2203 1.16797 7.00033 1.16797ZM7.58366 11.0846H6.41699V9.91797H7.58366V11.0846ZM8.79116 6.5638L8.26616 7.10047C7.84616 7.5263 7.58366 7.8763 7.58366 8.7513H6.41699V8.45964C6.41699 7.81797 6.67949 7.23464 7.09949 6.8088L7.82283 6.0738C8.03866 5.8638 8.16699 5.57214 8.16699 5.2513C8.16699 4.60964 7.64199 4.08464 7.00033 4.08464C6.35866 4.08464 5.83366 4.60964 5.83366 5.2513H4.66699C4.66699 3.96214 5.71116 2.91797 7.00033 2.91797C8.28949 2.91797 9.33366 3.96214 9.33366 5.2513C9.33366 5.76464 9.12366 6.2313 8.79116 6.5638Z",
    fill: "#3298F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelp);
export default __webpack_public_path__ + "static/media/icon_help.d458e37d998b4a789af3733816ac6f39.svg";
export { ForwardRef as ReactComponent };